"use client";
import { useRef, useEffect } from 'react';
import { useFn } from './useFn';

interface IUseInterval {
    autoStart: boolean;
    onStop?(): boolean;
    onStart?(): boolean;
    callback(): void;
    duration: number;
};

export const useInterval = ( { autoStart = true, callback, duration }: IUseInterval,deps: any[] = []) => {
  const callbackFn = useFn(callback);
  const isRunningRef = useRef(false);

  useEffect(() => {
    if (duration === null) {
      return;
    }

    let id: any;

    const runner = () => {
      id = setInterval(() => {
        callbackFn?.();
      }, duration);
    };

    const clearId = () => id && clearInterval(id);

    if (autoStart) {
        isRunningRef.current = true;
        clearId();
        runner();
    } else {
        clearId();
    }

    return clearId;
  }, [...deps, autoStart, duration]);
};
